import {
  CreateArtworkCollectionState,
  CreateArtworkCollectionType,
  CreateArtworkCollectionTypes,
} from "./data";

const initialState: CreateArtworkCollectionState = {
  code: "",
  image: "",
  launch_date: "",
  licensed_property: null,
  licensor: null,
  name: "",
  requesting_market: { full_name: "", id: "", short_name: "" },
  status: null,
  year: new Date().getFullYear().toString(),
  submitComment: "",
  isReadOnly:false,
  history:[],
  isValid:false,
};

const reducer = (
  state: CreateArtworkCollectionState,
  action: CreateArtworkCollectionType,
) => {
  if (action.type === CreateArtworkCollectionTypes.RESET) {
    return initialState;
  }

  if (action.type === CreateArtworkCollectionTypes.SET_ARTWORK_COLLECTION) {
    return { ...state, ...action.payload };
  }

  return { ...state, [action.type]: action.payload };
};

export const CreateArworkReducer = { initialState, reducer };
